import { useEffect, useRef } from "react";
import { usePopupLock } from "../../context/PopupLockContext";

export default function GlobalLoginHandler({
  onTrigger,
  blockLoginPopup = false,
}) {
  const timerRef = useRef(null);
  const isTriggeringRef = useRef(false);
  const lastTriggerTimeRef = useRef(0);
  const popupJustClosedRef = useRef(false);
  const timerStartTimeRef = useRef(null);
  const initialTriggerDoneRef = useRef(false);
  const { isAnyPopupOpen, locks } = usePopupLock();

  const isLoggedIn = () => {
    const user = JSON.parse(localStorage.getItem("medarphaUser") || "{}");
    return !!user?.userId;
  };

  const safeTrigger = () => {
    console.log("🔍 safeTrigger CALLED");
    console.log("🔍 isTriggeringRef:", isTriggeringRef.current);
    console.log("🔍 popupJustClosedRef:", popupJustClosedRef.current);
    console.log("🔍 isAnyPopupOpen:", isAnyPopupOpen);
    console.log("🔍 isLoggedIn:", isLoggedIn());
    console.log("🔍 blockLoginPopup:", blockLoginPopup);

    if (isTriggeringRef.current) {
      console.log("⏸️ GlobalLoginHandler: Already triggering, skipping");
      return;
    }

    const now = Date.now();
    if (now - lastTriggerTimeRef.current < 2000) {
      console.log("⏸️ GlobalLoginHandler: Too frequent, skipping");
      return;
    }

    // ✅ FIX: Agar popup close ho chuka hai aur timer complete ho gaya, toh allow karo
    if (popupJustClosedRef.current) {
      console.log("⏸️ GlobalLoginHandler: Popup just closed, but timer completed. Resetting...");
      popupJustClosedRef.current = false; // ✅ Reset and continue
      // Continue execution
    }

    if (isAnyPopupOpen) {
      console.log("⏸️ GlobalLoginHandler: Popup already open:", locks);
      return;
    }

    if (isLoggedIn()) {
      console.log("✅ GlobalLoginHandler: User already logged in");
      return;
    }

    if (blockLoginPopup) {
      console.log("⏸️ GlobalLoginHandler: Login popup blocked");
      return;
    }

    isTriggeringRef.current = true;
    lastTriggerTimeRef.current = now;
    
    console.log("====================================");
    console.log("🚀 GlobalLoginHandler: TRIGGERING LOGIN POPUP");
    console.log("🕐 Trigger Time:", new Date().toLocaleTimeString());
    
    if (timerStartTimeRef.current) {
      const elapsed = (now - timerStartTimeRef.current) / 1000;
      const minutes = Math.floor(elapsed / 60);
      const seconds = Math.floor(elapsed % 60);
      console.log(`⏱️ Time since timer started: ${minutes}m ${seconds}s`);
    }
    console.log("====================================");
    
    onTrigger();

    setTimeout(() => {
      isTriggeringRef.current = false;
    }, 1000);
  };

  // Detect when popup closes
  useEffect(() => {
    if (!isAnyPopupOpen && popupJustClosedRef.current) {
      console.log("====================================");
      console.log("⏱️ GlobalLoginHandler: POPUP CLOSED DETECTED");
      console.log("🕐 Close Time:", new Date().toLocaleTimeString());
      console.log("====================================");
      
      // ✅ Don't reset popupJustClosedRef here - keep it true to prevent immediate retrigger
      
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      
      timerStartTimeRef.current = Date.now();
      console.log("====================================");
      console.log("⏱️ GlobalLoginHandler: STARTING 2 MINUTE TIMER");
      console.log("🕐 Timer Start:", new Date().toLocaleTimeString());
      console.log("⏱️ Will trigger at:", new Date(Date.now() + 120000).toLocaleTimeString());
      console.log("====================================");
      
      timerRef.current = setTimeout(() => {
        console.log("====================================");
        console.log("⏱️ GlobalLoginHandler: 2 MINUTE TIMER COMPLETED");
        console.log("🕐 Trigger Time:", new Date().toLocaleTimeString());
        console.log("====================================");
        // ✅ Timer complete hone par popupJustClosedRef ko reset karein
        popupJustClosedRef.current = false;
        safeTrigger();
      }, 120000);
    }
  }, [isAnyPopupOpen]);

  const startTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    if (isAnyPopupOpen || isLoggedIn() || blockLoginPopup) {
      console.log("⏸️ GlobalLoginHandler: Timer not started (popup open or logged in)");
      return;
    }

    timerStartTimeRef.current = Date.now();
    console.log("====================================");
    console.log("⏱️ GlobalLoginHandler: STARTING 2 MINUTE TIMER");
    console.log("🕐 Timer Start:", new Date().toLocaleTimeString());
    console.log("⏱️ Will trigger at:", new Date(Date.now() + 120000).toLocaleTimeString());
    console.log("====================================");
    
    timerRef.current = setTimeout(() => {
      console.log("====================================");
      console.log("⏱️ GlobalLoginHandler: 2 MINUTE TIMER COMPLETED");
      console.log("🕐 Trigger Time:", new Date().toLocaleTimeString());
      console.log("====================================");
      popupJustClosedRef.current = false; // ✅ Reset before triggering
      safeTrigger();
    }, 120000);
  };

  useEffect(() => {
    if (isLoggedIn()) {
      console.log("✅ GlobalLoginHandler: User logged in, stopping");
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      return;
    }

    if (!isLoggedIn() && !blockLoginPopup && !isAnyPopupOpen && !initialTriggerDoneRef.current) {
      initialTriggerDoneRef.current = true;
      const initTimer = setTimeout(() => {
        console.log("====================================");
        console.log("🚀 GlobalLoginHandler: INITIAL TRIGGER (ONCE)");
        console.log("🕐 Time:", new Date().toLocaleTimeString());
        console.log("====================================");
        safeTrigger();
      }, 1000);
      
      return () => clearTimeout(initTimer);
    }

    if (!isAnyPopupOpen && !isLoggedIn() && !blockLoginPopup) {
      startTimer();
    }

    const resetTimer = () => {
      if (isLoggedIn() || blockLoginPopup || isAnyPopupOpen) {
        return;
      }
      
      if (popupJustClosedRef.current) {
        return;
      }
      
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      startTimer();
    };

    const events = ["click", "scroll", "keydown"];

    events.forEach((event) =>
      window.addEventListener(event, resetTimer)
    );

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );

      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [blockLoginPopup, isAnyPopupOpen]);

  return null;
}